<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-history-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Historique des documents commerciaux</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between " style="display: block">


                            <div class="cf-toolbar-row">
                                <div class="search-wrap">
                                    <i class="ri-search-line search-icon"></i>
                                    <input v-model="searchword" type="search" class="search-input"
                                           placeholder="Rechercher par entrepôt / N° document">
                                    <button v-if="searchword" @click="searchword=''" class="search-clear" aria-label="Effacer"><i class="ri-close-line"></i></button>
                                </div>
                            </div>

                            <div class="cf-toolbar-meta">

                                <div class="cf-period">
                                    <div class="cf-perpage">
                                        <label>Du</label>
                                        <input class="cf-date-inp" type="date" @change="load" v-model="datedebut" placeholder="Date début">
                                    </div>
                                    <div class="cf-perpage">
                                        <label>au</label>
                                        <input class="cf-date-inp" type="date" @change="load" v-model="datefin" placeholder="Date fin">
                                    </div>
                                </div>

                                <div class="cf-perpage">
                                    <label>Trie document</label>
                                    <div class="cf-select-wrap">
                                        <select v-model="searchtrierletableau" class="cf-select--sm" aria-label="Trie document" title="Trie document">
                                            <option value=""></option>
                                            <option value="BON DE COMMANDE CLT">BON DE COMMANDE CLT</option>
                                            <option value="BON DE LIVRAISON">BON DE LIVRAISON</option>
                                            <option value="FACTURE CLT">FACTURE CLT</option>
                                            <option value="FACTURE D'AVOIR CLT">FACTURE D'AVOIR CLT</option>
                                            <option value="BON DE RETOUR CLT">BON DE RETOUR CLT</option>
                                            <option value="BON DE COMMANDE FRS">BON DE COMMANDE FRS</option>
                                            <option value="FACTURE D'AVOIR FRS">FACTURE D'AVOIR FRS</option>
                                            <option value="BON DE RETOUR FRS">BON DE RETOUR FRS</option>
                                            <option value="FACTURE D'AVOIR CLT">FACTURE D'AVOIR CLT</option>
                                            <option value="BON DE RECEPTION FRS">BON DE RECEPTION FRS</option>
                                            <option value="DEVIS/PROFORMA">DEVIS/PROFORMA</option>
                                            <option value="DEMANDE D'ACHAT">DEMANDE D'ACHAT</option>
                                            <option value="BON DE PREPARATION DE LIVRAISON">BON DE PREPARATION DE LIVRAISON</option>
                                        </select>
                                        <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                    </div>
                                </div>

                                <div class="cf-perpage">
                                    <label>Afficher</label>
                                    <div class="cf-select-wrap">
                                        <select v-model="DefaultperPage" class="cf-select--sm" aria-label="Page Size" title="Affichage">
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="150">150</option>
                                            <option value="200">200</option>
                                            <option value="250">250</option>
                                            <option value="300">300</option>
                                        </select>
                                        <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                    </div>
                                </div>

                            </div>

                        </div>


                        <div class="box-body !p-0 mybodyheight300px">
                            <div class="table-responsive">

                                <!-- component -->

                                <div class="flex flex-col h-screen">
                                    <div class="flex-grow overflow-auto">

                                   <table class="relative w-full border table mytable table-hover whitespace-nowrap min-w-full">
                                            <thead>
                                            <tr>
                                                <!--th scope="col" class="th text-start">N°</th-->
                                                <th scope="col" class="th text-start">TYPE DE DOCUMENT</th>
                                                <th scope="col" class="th text-start">N° DOCUMENT</th>
                                                <!--th scope="col" class="th text-start">DATE</th-->
                                                <th scope="col" class="th text-start">MAGASIN/DEPÔT/ENTREPÔT</th>
                                                <th scope="col" class="th text-start">CLIENT/FOURNISSEUR</th>
                                                <!--th scope="col" class="th text-start">OBSERVATION</th-->
                                                <th scope="col" class="th text-start">N°BON</th>
                                                <th scope="col" class="th text-start">CREER LE</th>
                                                <th scope="col" class="th text-start">CREER PAR</th>
                                                <th scope="col" class="th th--center">ACTION</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            <template v-if="filterdatatable.length">

                                                <tr  class="table-row" v-for="(datavalue,index) in filterdatatable" :key="index">

                                                    <td class="td" data-label="TYPE DE DOCUMENT  : "   >{{ datavalue.mtypdoc }}</td>
                                                    <td class="td" data-label="N° DOCUMENT  : "   >{{ datavalue.numdoc }}</td>
                                                    <!--td  data-label="DATE  : "   >{{ datavalue.datedoc }}</td-->
                                                    <td class="td" data-label="MAGASIN/DEPÔT/ENTREPÔT  : "   >{{ datavalue.magname }}</td>
                                                    <td class="td" data-label="CLIENT/FOURNISSEUR  : "   >{{ datavalue.cltfrsname }}</td>
                                                    <!--td  data-label="OBSERVATION  : "   >{{ datavalue.observations }}</td-->
                                                    <td class="td" data-label="N°BON  : "   >{{ datavalue.numbon }}</td>
                                                    <td class="td" data-label="CREER LE  : "   >{{ datavalue.creerler }}</td>
                                                    <td class="td" data-label="CREER PAR  : "   >{{ datavalue.saisiepar }}</td>
                                                     <td class="td td--center" data-label="ACTION  : " style="overflow:visible;" @click.stop >


                                                        <div class="ti-btn-group" style="position:relative;display:inline-block;">
                                                            <button class="ds-btn-ghost !py-1 !px-2 !text-[0.75rem]" type="button"
                                                                    :aria-expanded="openMenu === 'row_' + index"
                                                                    @click.stop="toggleMenu('row_' + index)">
                                                                <i class="ri-more-2-fill"></i>
                                                            </button>
                                                            <ul v-show="openMenu === 'row_' + index" class="ag-menu">


                                                                <li>
                                                                    <button @click="btnopen(datavalue);openMenu=null" class="ag-menu-item">
                                                                        <i class="ri-folder-open-line cf-menu-icon"></i> Ouvrir
                                                                    </button>
                                                                </li>

                                                                <li v-if="datavalue.nbp>0">
                                                                    <button @click="btnimpression(datavalue);openMenu=null" class="ag-menu-item">
                                                                        <i class="ri-printer-line cf-menu-icon"></i> Imprimer
                                                                    </button>
                                                                </li>



                                                            </ul>
                                                        </div>




                                                    </td>

                                                </tr>



                                            </template>


                                            <template v-else>
                                                <tr >
                                                    <td colspan="20" class="td">
                                                        <div class="empty-state">
                                                            <div class="empty-state__icon"><i class="ri-file-list-3-line"></i></div>
                                                            <p class="empty-state__title">Aucun enregistrement trouvé</p>
                                                            <p class="empty-state__sub">Aucun document ne correspond à vos critères sur la période sélectionnée</p>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </template>



                                            </tbody>
                                        </table>


                                    </div>
                                </div>

                            </div>
                        </div>





                        <div class="flex flex-col box-footer border-t-0 ">
                            <div class="flex items-center flex-wrap overflow-auto">
                                <div class="mb-2 sm:mb-0">

                                </div>
                                <div class="ms-auto">


                                    <div class="pagination" v-if="pages.length > 1">
                                        <button class="page-btn page-btn--nav" @click="page--" :disabled="page <= 1"><i class="ri-arrow-left-s-line"></i></button>
                                        <template v-for="(pageNumber, key) in displayedPages" :key="key">
                                            <span v-if="pageNumber === '...'" class="cf-ellipsis">…</span>
                                            <button v-else class="page-btn" :class="{ 'page-btn--active': pageNumber === page }" @click="page = pageNumber">
                                                {{ pageNumber }}
                                            </button>
                                        </template>
                                        <button class="page-btn page-btn--nav" @click="page++" :disabled="page >= pages.length"><i class="ri-arrow-right-s-line"></i></button>
                                    </div>




                                </div>
                            </div>
                        </div>
                    </div>






                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>


    <modalopenform ref="modalopenform"  ></modalopenform>



    <achat_bcd_etat0 ref="achat_bcd_etat0"  ></achat_bcd_etat0>
    <achat_bcd_etat1 ref="achat_bcd_etat1"  ></achat_bcd_etat1>
    <achat_bcd_etat2 ref="achat_bcd_etat2"  ></achat_bcd_etat2>
    <achat_bcd_etat3 ref="achat_bcd_etat3"  ></achat_bcd_etat3>
    <achat_bcd_etat4 ref="achat_bcd_etat4"  ></achat_bcd_etat4>
    <achat_bcd_etat5 ref="achat_bcd_etat5"  ></achat_bcd_etat5>

    <achat_bondereception_etat0 ref="achat_bondereception_etat0"  ></achat_bondereception_etat0>
    <achat_demandedachat_etat0 ref="achat_demandedachat_etat0"  ></achat_demandedachat_etat0>
    <achat_facture_etat0 ref="achat_facture_etat0"  ></achat_facture_etat0>
    <achat_retour_etat0 ref="achat_retour_etat0"  ></achat_retour_etat0>

    <vente_bcd_etat0 ref="vente_bcd_etat0"  ></vente_bcd_etat0>
    <vente_bl_etat0 ref="vente_bl_etat0"  ></vente_bl_etat0>
    <vente_bpl_etat0 ref="vente_bpl_etat0"  ></vente_bpl_etat0>
    <vente_facture_etat0 ref="vente_facture_etat0"  ></vente_facture_etat0>
    <vente_retour_etat0 ref="vente_retour_etat0"  ></vente_retour_etat0>


    <achat_bondereception_etat1 ref="achat_bondereception_etat1"  ></achat_bondereception_etat1>
    <achat_bondereception_etat2 ref="achat_bondereception_etat2"  ></achat_bondereception_etat2>
    <achat_bondereception_etat3 ref="achat_bondereception_etat3"  ></achat_bondereception_etat3>
    <achat_bondereception_etat4 ref="achat_bondereception_etat4"  ></achat_bondereception_etat4>
    <achat_bondereception_etat5 ref="achat_bondereception_etat5"  ></achat_bondereception_etat5>
    <achat_demandedachat_etat1 ref="achat_demandedachat_etat1"  ></achat_demandedachat_etat1>
    <achat_demandedachat_etat2 ref="achat_demandedachat_etat2"  ></achat_demandedachat_etat2>
    <achat_demandedachat_etat3 ref="achat_demandedachat_etat3"  ></achat_demandedachat_etat3>
    <achat_demandedachat_etat4 ref="achat_demandedachat_etat4"  ></achat_demandedachat_etat4>
    <achat_demandedachat_etat5 ref="achat_demandedachat_etat5"  ></achat_demandedachat_etat5>
    <achat_facture_etat1 ref="achat_facture_etat1"  ></achat_facture_etat1>
    <achat_facture_etat2 ref="achat_facture_etat2"  ></achat_facture_etat2>
    <achat_facture_etat3 ref="achat_facture_etat3"  ></achat_facture_etat3>
    <achat_facture_etat4 ref="achat_facture_etat4"  ></achat_facture_etat4>
    <achat_facture_etat5 ref="achat_facture_etat5"  ></achat_facture_etat5>
    <achat_retour_etat1 ref="achat_retour_etat1"  ></achat_retour_etat1>
    <achat_retour_etat2 ref="achat_retour_etat2"  ></achat_retour_etat2>
    <achat_retour_etat3 ref="achat_retour_etat3"  ></achat_retour_etat3>
    <achat_retour_etat4 ref="achat_retour_etat4"  ></achat_retour_etat4>
    <achat_retour_etat5 ref="achat_retour_etat5"  ></achat_retour_etat5>
    <vente_bcd_etat1 ref="vente_bcd_etat1"  ></vente_bcd_etat1>
    <vente_bcd_etat2 ref="vente_bcd_etat2"  ></vente_bcd_etat2>
    <vente_bcd_etat3 ref="vente_bcd_etat3"  ></vente_bcd_etat3>
    <vente_bcd_etat4 ref="vente_bcd_etat4"  ></vente_bcd_etat4>
    <vente_bcd_etat5 ref="vente_bcd_etat5"  ></vente_bcd_etat5>
    <vente_bl_etat1 ref="vente_bl_etat1"  ></vente_bl_etat1>
    <vente_bl_etat2 ref="vente_bl_etat2"  ></vente_bl_etat2>
    <vente_bl_etat3 ref="vente_bl_etat3"  ></vente_bl_etat3>
    <vente_bl_etat4 ref="vente_bl_etat4"  ></vente_bl_etat4>
    <vente_bl_etat5 ref="vente_bl_etat5"  ></vente_bl_etat5>
    <vente_bpl_etat1 ref="vente_bpl_etat1"  ></vente_bpl_etat1>

    <vente_bpl_etat2 ref="vente_bpl_etat2"  ></vente_bpl_etat2>
    <vente_bpl_etat3 ref="vente_bpl_etat3"  ></vente_bpl_etat3>
    <vente_bpl_etat4 ref="vente_bpl_etat4"  ></vente_bpl_etat4>
    <vente_bpl_etat5 ref="vente_bpl_etat5"  ></vente_bpl_etat5>
    <vente_devis_etat0 ref="vente_devis_etat0"  ></vente_devis_etat0>
    <vente_devis_etat1 ref="vente_devis_etat1"  ></vente_devis_etat1>
    <vente_devis_etat2 ref="vente_devis_etat2"  ></vente_devis_etat2>
    <vente_devis_etat3 ref="vente_devis_etat3"  ></vente_devis_etat3>
    <vente_devis_etat4 ref="vente_devis_etat4"  ></vente_devis_etat4>
    <vente_devis_etat5 ref="vente_devis_etat5"  ></vente_devis_etat5>
    <vente_facture_etat0 ref="vente_facture_etat0"  ></vente_facture_etat0>
    <vente_facture_etat1 ref="vente_facture_etat1"  ></vente_facture_etat1>
    <vente_facture_etat2 ref="vente_facture_etat2"  ></vente_facture_etat2>
    <vente_facture_etat3 ref="vente_facture_etat3"  ></vente_facture_etat3>
    <vente_facture_etat4 ref="vente_facture_etat4"  ></vente_facture_etat4>
    <vente_facture_etat5 ref="vente_facture_etat5"  ></vente_facture_etat5>
    <vente_retour_etat1 ref="vente_retour_etat1"  ></vente_retour_etat1>
    <vente_retour_etat2 ref="vente_retour_etat2"  ></vente_retour_etat2>
    <vente_retour_etat3 ref="vente_retour_etat3"  ></vente_retour_etat3>
    <vente_retour_etat4 ref="vente_retour_etat4"  ></vente_retour_etat4>
    <vente_retour_etat5 ref="vente_retour_etat5"  ></vente_retour_etat5>














</template>

<script>




    import qrcodetoimage from "qrcode";

    const axios =require('axios');


    import {isset, isValidDateString, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import modalopenform from "@/components/views/pages/gestioncommerciale/achatvente/modal_openform";
    import achat_bcd_etat0 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bcd/0";
    import achat_bcd_etat1 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bcd/1";
    import achat_bcd_etat2 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bcd/2";
    import achat_bcd_etat3 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bcd/3";
    import achat_bcd_etat4 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bcd/4";
    import achat_bcd_etat5 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bcd/5";
    import achat_bondereception_etat0
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bondereception/0";
    import achat_demandedachat_etat0
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_demandedachat/0";
    import achat_facture_etat0 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_facture/0";
    import achat_retour_etat0 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_retour/0";
    import vente_bcd_etat0 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bcd/0";
    import vente_bpl_etat0 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bpl/0";
    import vente_bl_etat0 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bl/0";
    import vente_retour_etat0 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_retour/0";
    import achat_bondereception_etat1
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bondereception/1";
    import achat_bondereception_etat2
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bondereception/2";
    import achat_bondereception_etat3
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bondereception/3";
    import achat_bondereception_etat4
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bondereception/4";
    import achat_bondereception_etat5
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_bondereception/5";
    import achat_demandedachat_etat1
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_demandedachat/1";
    import achat_demandedachat_etat2
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_demandedachat/2";
    import achat_demandedachat_etat3
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_demandedachat/3";
    import achat_demandedachat_etat4
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_demandedachat/4";
    import achat_demandedachat_etat5
        from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_demandedachat/5";
    import achat_facture_etat1 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_facture/1";
    import achat_facture_etat2 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_facture/2";
    import achat_facture_etat3 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_facture/3";
    import achat_facture_etat4 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_facture/4";
    import achat_facture_etat5 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_facture/5";
    import achat_retour_etat1 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_retour/1";
    import achat_retour_etat2 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_retour/2";
    import achat_retour_etat3 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_retour/3";
    import achat_retour_etat4 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_retour/4";
    import achat_retour_etat5 from "@/components/views/pages/gestioncommerciale/achatvente/etat/achat_retour/5";
    import vente_bcd_etat1 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bcd/1";
    import vente_bcd_etat2 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bcd/2";
    import vente_bcd_etat3 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bcd/3";
    import vente_bcd_etat4 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bcd/4";
    import vente_bcd_etat5 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bcd/5";
    import vente_bl_etat1 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bl/1";
    import vente_bl_etat2 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bl/2";
    import vente_bl_etat3 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bl/3";
    import vente_bl_etat4 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bl/4";
    import vente_bl_etat5 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bl/5";
    import vente_bpl_etat1 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bpl/1";
    import vente_bpl_etat2 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bpl/2";
    import vente_bpl_etat3 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bpl/3";
    import vente_bpl_etat4 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bpl/4";
    import vente_bpl_etat5 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_bpl/5";
    import vente_devis_etat0 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_devis/0";
    import vente_devis_etat1 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_devis/1";
    import vente_devis_etat2 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_devis/2";
    import vente_devis_etat3 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_devis/3";
    import vente_devis_etat4 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_devis/4";
    import vente_devis_etat5 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_devis/5";
    import vente_facture_etat0 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/0";
    import vente_facture_etat1 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/1";
    import vente_facture_etat2 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/2";
    import vente_facture_etat3 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/3";
    import vente_facture_etat4 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/4";
    import vente_facture_etat5 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_facture/5";
    import vente_retour_etat1 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_retour/1";
    import vente_retour_etat2 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_retour/2";
    import vente_retour_etat3 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_retour/3";
    import vente_retour_etat4 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_retour/4";
    import vente_retour_etat5 from "@/components/views/pages/gestioncommerciale/achatvente/etat/vente_retour/5";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },

            searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

            },


        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

                if (this.searchtrierletableau!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return   post.mtypdoc.toLowerCase()===t.searchtrierletableau.toLowerCase()

                    })

                }


                if (this.searchword!==''){
                    let t=this;



                    mvalue = mvalue.filter( function (post) {
                        return    post.numdoc.toLowerCase().includes(t.searchword.toLowerCase())
                                 || post.magname.toLowerCase().includes(t.searchword.toLowerCase())

                    })

                }



                return this.paginate(mvalue) ;
            },
        },
        components: {



            modalopenform,
            achat_bcd_etat0,
            achat_bcd_etat1,
            achat_bcd_etat2,
            achat_bcd_etat3,
            achat_bcd_etat4,
            achat_bcd_etat5,

            achat_bondereception_etat0,
            achat_demandedachat_etat0,
            achat_facture_etat0,
            achat_retour_etat0,
            vente_bcd_etat0,
            vente_bpl_etat0,
            vente_bl_etat0,
            vente_retour_etat0,

            achat_bondereception_etat1,
            achat_bondereception_etat2,
            achat_bondereception_etat3,
            achat_bondereception_etat4,
            achat_bondereception_etat5,
            achat_demandedachat_etat1,
            achat_demandedachat_etat2,
            achat_demandedachat_etat3,
            achat_demandedachat_etat4,
            achat_demandedachat_etat5,
            achat_facture_etat1,
            achat_facture_etat2,
            achat_facture_etat3,
            achat_facture_etat4,
            achat_facture_etat5,
            achat_retour_etat1,
            achat_retour_etat2,
            achat_retour_etat3,
            achat_retour_etat4,
            achat_retour_etat5,
            vente_bcd_etat1,
            vente_bcd_etat2,
            vente_bcd_etat3,
            vente_bcd_etat4,
            vente_bcd_etat5,
            vente_bl_etat1,
            vente_bl_etat2,
            vente_bl_etat3,
            vente_bl_etat4,
            vente_bl_etat5,
            vente_bpl_etat1,
            vente_bpl_etat2,
            vente_bpl_etat3,
            vente_bpl_etat4,
            vente_bpl_etat5,
            vente_devis_etat0,
            vente_devis_etat1,
            vente_devis_etat2,
            vente_devis_etat3,
            vente_devis_etat4,
            vente_devis_etat5,
            vente_facture_etat0,
            vente_facture_etat1,
            vente_facture_etat2,
            vente_facture_etat3,
            vente_facture_etat4,
            vente_facture_etat5,
            vente_retour_etat1,
            vente_retour_etat2,
            vente_retour_etat3,
            vente_retour_etat4,
            vente_retour_etat5,



        },

        data() {
            return {
                isdisplay:false,
                openMenu:null,
                titlemodal:"",
                datatable:[],
                otherdata:[],
                listedupersonnel:[],
                datatiers:[],
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                datedebut:"",
                datefin:"",
                indexbutton:'1d',





                searchword:"",
                searchtrierletableau:"",

                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {

            // ── Menu 3 points (charte : un seul menu ouvert + clic extérieur) ──
            toggleMenu(key) {
                this.openMenu = this.openMenu === key ? null : key;
            },
            handleGlobalClick(e) {
                if (!e.target.closest('.ti-btn-group') && !e.target.closest('.ag-menu')) {
                    this.openMenu = null;
                }
            },

            async load(){



                if (!isValidDateString(this.datedebut) || !isValidDateString(this.datefin)){return }

                this.isdisplay=true;

                        this.$store.dispatch('lancerchargement',true)

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/jkebfgescomporziprodpfachatventeegl745874stock771714dfe/gescom/rapport/periode/'+this.$store.state.appsociete+'/'+this.datedebut+'/'+this.datefin+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.datatable=[];
                            t.datatable=res.data.m;
                             t.isdisplay=true;

                        }
                        else{
                            t.datatable=[];

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },



            async btnimpression(value){


                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/'+value.numdoc+'/'+value.pid+'/open/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            // t.listedatatableproduit=[];
                            // t.listedatatableproduit=res.data.m;

                            /*  t.Items.jsonotherdonne=Items.jsonotherdonne;
                              t.Items.mag=Items.mag;
                              t.Items.pid=Items.pid;
                              t.ItemsArticle.docpid=Items.pid;
                              t.Items.params=Items.params;
                              t.Items.mtnt=Items.mtnt;
                              t.Items.docnum=Items.numdoc;*/


                            /*t.Items.docnumother=Items.docnumother;
                            t.Items.docpid=Items.pid;
                            t.Items.pid=Items.pid;
                            t.Items.infodoc=Items.infodoc;
                            t.Items.datedoc=Items.datedoc;
                            t.Items.doctyp=Items.doctyp;
                            t.Items.docobservation=Items.observations;*/


                            //t.listearticles=response.data.allprod;

                            value.alllignedoc=res.data.alllignedoc;


                            /*t.listedatatable=res.data.alllignedoc;
                            t.mydocmag=Items.mag.pid;
                            t.ItemsArticle.docmag=Items.mag.pid;
                            //t.itemArticle.docnum=value.numdoc;
                            t.ItemsArticle.docnum=Items.pid;
                            t.ItemsArticle.doctp=Items.doctyp;
                            t.ItemsArticle.docnumother=Items.docotherref;*/


                            t.callimprimer(value);

                            /*t.isdisplayviewarticle=true;
                            t.isdisplay=true;*/

                        }
                        else{
                            t.listedatatableproduit=[];
                            // t.isdisplay=true;

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })



            },


            callimprimer(value) {



                let   tabvalue={}



                tabvalue={
                    jsoncltfrs:{
                        typcltfrs:'',
                        raisonsociale:value.jsonotherdonne.cltfrs.name,
                        ifu:value.jsonotherdonne.cltfrs.ifu,
                        telephone:value.jsonotherdonne.cltfrs.telephone,
                        adresse:value.jsonotherdonne.cltfrs.adresse,
                        codeclient:value.jsonotherdonne.cltfrs.codecltfrs
                    },
                    jsoncol:{
                        name:'',
                    },
                    titresignataire:"",
                    nomdusignataire:"",
                    texteavance:String(value.jsonotherdonne.piedsinfodoc.infolibre),
                    textesole:String(value.jsonotherdonne.piedsinfodoc.infolibre1),
                    infolibre2:String(value.jsonotherdonne.piedsinfodoc.infolibre2),

                    infolibre:String(value.jsonotherdonne.infodoc.infolibre),
                    infolibre1:String(value.jsonotherdonne.infodoc.infolibre1),
                    infolibre22:String(value.jsonotherdonne.infodoc.infolibre2),
                    infolibre3:String(value.jsonotherdonne.infodoc.infolibre3),
                    infolibre4:String(value.jsonotherdonne.infodoc.infolibre4),
                    infolibre5:String(value.jsonotherdonne.infodoc.infolibre5),
                    infolibre6:String(value.jsonotherdonne.infodoc.infolibre6),
                    infolibre7:String(value.jsonotherdonne.infodoc.infolibre7),
                    infolibre8:String(value.jsonotherdonne.infodoc.infolibre8),
                    infolibre9:String(value.jsonotherdonne.infodoc.infolibre9),
                    infolibre10:String(value.jsonotherdonne.infodoc.infolibre10),
                    infolibre11:String(value.jsonotherdonne.infodoc.infolibre11),

                    libelledefacture:value.doctyp,
                    cltfrs:value.jsonotherdonne.cltfrs.name,
                    numdoc:value.numdoc,
                    operateur:value.saisiepar,
                    othernumdoc:value.numbon,

                    observations:value.mobservations,
                    date:value.datedoc,
                    items:value.alllignedoc,
                    montantht:parseFloat(value.mtnt.docmtnttotalht),
                    montanttva:parseFloat(value.mtnt.doctva),
                    montantremise:parseFloat(value.mtnt.docmtntremise),
                    montantnetapayer:parseFloat(value.mtnt.docmtnttotalttc),
                    montantaib:parseFloat(value.mtnt.docmtntaib),
                    libaib:value.mtnt.libaib,

                    formattext:'',

                    mecefsignature:'',
                    mecefnim:'',
                    mecefcompteur:'',
                    mecefheure:'',
                    mecefqrr:'',
                    normalise:0,


                    /************************** signature ****************/

                    signature:{
                        titredoc:"",
                        titresignataire:"",
                        namesignataire:"",
                        imgsignature:"",
                        datasignataires:[],
                        imgsignataires:[]
                    }




                }



                if(value.doctyp==='PF'){

                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.ventedevis.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.ventedevis.signataires


                    tabvalue.jsoncltfrs.typcltfrs="CLIENT";

                    if (parseInt(this.$store.state.paramsapp.signataire.ventedevis.document)===0){
                        this.$refs.vente_devis_etat0.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventedevis.document)===1){
                        this.$refs.vente_devis_etat1.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventedevis.document)===2){
                        this.$refs.vente_devis_etat2.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventedevis.document)===3){
                        this.$refs.vente_devis_etat3.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventedevis.document)===4){
                        this.$refs.vente_devis_etat4.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventedevis.document)===5){
                        this.$refs.vente_devis_etat5.show(tabvalue);
                    }



                }

                if(value.doctyp==='BC'){

                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.ventebcd.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.ventebcd.signataires


                    tabvalue.jsoncltfrs.typcltfrs="CLIENT";

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebcd.document)===0){
                        this.$refs.vente_bcd_etat0.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebcd.document)===1){
                        this.$refs.vente_bcd_etat1.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebcd.document)===2){
                        this.$refs.vente_bcd_etat2.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebcd.document)===3){
                        this.$refs.vente_bcd_etat3.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebcd.document)===4){
                        this.$refs.vente_bcd_etat4.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebcd.document)===5){
                        this.$refs.vente_bcd_etat5.show(tabvalue);
                    }



                }

                if(value.doctyp==='BPL'){

                    tabvalue.jsoncltfrs.typcltfrs="CLIENT";

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebpl.document)===0){
                        this.$refs.vente_bpl_etat0.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebpl.document)===1){

                        tabvalue.jsoncol.name=isset(value.jsonotherdonne.collaborateur)?value.jsonotherdonne.collaborateur.name:"";
                        let formattext='';

                        value.alllignedoc.forEach(function (line) {


                            if (formattext===''){


                                formattext=line.qtite+' '+line.article.libelle;

                            }else{

                                formattext+=', '+line.qtite+' '+line.article.libelle;

                            }

                        })

                        tabvalue.formattext=formattext;



                        tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.ventebpl.titredoc
                        tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.ventebpl.signataires




                        this.$refs.vente_bpl_etat1.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebpl.document)===2){
                        this.$refs.vente_bpl_etat2.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebpl.document)===3){
                        this.$refs.vente_bpl_etat3.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebpl.document)===4){
                        this.$refs.vente_bpl_etat4.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.ventebpl.document)===5){
                        this.$refs.vente_bpl_etat5.show(tabvalue);
                    }



                }

                if(value.doctyp==='BL'){
                    tabvalue.jsoncltfrs.typcltfrs="CLIENT";

                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.ventebl.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.ventebl.signataires



                    if (parseInt(this.$store.state.paramsapp.signataire.ventebl.document)===0){
                        this.$refs.vente_bl_etat0.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventebl.document)===1){


                        tabvalue.jsoncol.name=value.jsonotherdonne.collaborateur.name;
                        let formattext='';

                        value.alllignedoc.forEach(function (line) {


                            if (formattext===''){


                                formattext=line.qtite+' '+line.article.libelle;

                            }else{

                                formattext+=', '+line.qtite+' '+line.article.libelle;

                            }

                        })

                        tabvalue.formattext=formattext;






                        this.$refs.vente_bl_etat1.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventebl.document)===2){
                        this.$refs.vente_bl_etat2.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventebl.document)===3){
                        this.$refs.vente_bl_etat3.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventebl.document)===4){
                        this.$refs.vente_bl_etat4.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventebl.document)===5){
                        this.$refs.vente_bl_etat5.show(tabvalue);
                    }



                }

                if(value.doctyp==='F'){


                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.ventefacture.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.ventefacture.signataires


                    tabvalue.jsoncltfrs.typcltfrs="CLIENT";

                    if (value.infodoc.normalise===1 || value.infodoc.normalise==='1'){




                        let urlimagegenerer="";

                        // Générer un QR code sous forme d'URL de données
                        qrcodetoimage.toDataURL(value.infodoc.doccollecte.data.qrCode, { width: 125, margin: 2 }, (err, url) => {
                            if (err) {
                                console.error(err);
                            } else {

                                urlimagegenerer=  url;
                            }
                        });


                        tabvalue.mecefsignature=value.infodoc.doccollecte.data.codeMECeFDGI
                        tabvalue.mecefnim=value.infodoc.doccollecte.data.nim
                        tabvalue.mecefcompteur=value.infodoc.doccollecte.data.counters
                        tabvalue.mecefheure=value.infodoc.doccollecte.data.dateTime
                        //tabvalue.mecefqrr=value.infodoc.doccollecte.data.qrCode
                        tabvalue.mecefqrr=urlimagegenerer,
                            tabvalue.normalise=value.infodoc.normalise

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===0){

                        this.$refs.vente_facture_etat0.show(tabvalue);

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===1){



                        this.$refs.vente_facture_etat1.show(tabvalue);

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===2){

                        this.$refs.vente_facture_etat2.show(tabvalue);

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===3){

                        this.$refs.vente_facture_etat3.show(tabvalue);

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===4){

                        this.$refs.vente_facture_etat4.show(tabvalue);

                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.ventefacture.document)===5){

                        this.$refs.vente_facture_etat5.show(tabvalue);

                    }



                }


                if(value.doctyp==='BR'){
                    tabvalue.jsoncltfrs.typcltfrs="CLIENT";

                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.venteretour.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.venteretour.signataires



                    if (value.infodoc.normalise===1){
                        tabvalue.mecefreference=value.infodoc.collecte.doccollecte.dataemecef.reference
                        tabvalue.mecefsignature=value.infodoc.collecte.doccollecte.data.codeMECeFDGI
                        tabvalue.mecefnim=value.infodoc.collecte.doccollecte.data.nim
                        tabvalue.mecefcompteur=value.infodoc.collecte.doccollecte.data.counters
                        tabvalue.mecefheure=value.infodoc.collecte.doccollecte.data.dateTime
                        //tabvalue.mecefqrr=value.infodoc.collecte.doccollecte.data.qrCode
                        tabvalue.mecefqrr="https://chart.googleapis.com/chart?cht=qr&chl="+value.infodoc.collecte.doccollecte.data.qrCode+"&chs=100x100&chld=L|0",
                            tabvalue.normalise=value.infodoc.normalise
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.venteretour.document)===0){
                        this.$refs.vente_retour_etat0.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.venteretour.document)===1){
                        this.$refs.vente_retour_etat1.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.venteretour.document)===2){
                        this.$refs.vente_retour_etat2.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.venteretour.document)===3){
                        this.$refs.vente_retour_etat3.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.venteretour.document)===4){
                        this.$refs.vente_retour_etat4.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.venteretour.document)===5){
                        this.$refs.vente_retour_etat5.show(tabvalue);
                    }



                }

                //**************************   ACHAT   **************************************//

                if(value.doctyp==='DAF'){

                    tabvalue.jsoncltfrs.typcltfrs="FOURNISSEUR";

                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.demandedachat.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.demandedachat.signataires


                    if (parseInt(this.$store.state.paramsapp.signataire.demandedachat.document)===0){
                        this.$refs.achat_demandedachat_etat0.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.demandedachat.document)===1){
                        this.$refs.achat_demandedachat_etat1.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.demandedachat.document)===2){
                        this.$refs.achat_demandedachat_etat2.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.demandedachat.document)===3){
                        this.$refs.achat_demandedachat_etat3.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.demandedachat.document)===4){
                        this.$refs.achat_demandedachat_etat4.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.demandedachat.document)===5){
                        this.$refs.achat_demandedachat_etat5.show(tabvalue);
                    }



                }


                if(value.doctyp==='BCF'){

                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.achatbcd.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.achatbcd.signataires


                    tabvalue.jsoncltfrs.typcltfrs="FOURNISSEUR / SUPPLIER";

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbcd.document)===0){
                        this.$refs.achat_bcd_etat0.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbcd.document)===1){

                        this.$refs.achat_bcd_etat1.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbcd.document)===2){
                        this.$refs.achat_bcd_etat2.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbcd.document)===3){
                        this.$refs.achat_bcd_etat3.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbcd.document)===4){
                        this.$refs.achat_bcd_etat4.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbcd.document)===5){
                        this.$refs.achat_bcd_etat5.show(tabvalue);
                    }



                }


                if(value.doctyp==='BRF'){

                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.achatbondereception.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.achatbondereception.signataires


                    tabvalue.jsoncltfrs.typcltfrs="FOURNISSEUR";

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbondereception.document)===0){
                        this.$refs.achat_bondereception_etat0.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbondereception.document)===1){
                        this.$refs.achat_bondereception_etat1.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbondereception.document)===2){
                        this.$refs.achat_bondereception_etat2.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbondereception.document)===3){
                        this.$refs.achat_bondereception_etat3.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbondereception.document)===4){
                        this.$refs.achat_bondereception_etat4.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatbondereception.document)===5){
                        this.$refs.achat_bondereception_etat5.show(tabvalue);
                    }



                }


                if(value.doctyp==='FR'){

                    tabvalue.jsoncltfrs.typcltfrs="FOURNISSEUR";

                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.achatfacture.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.achatfacture.signataires


                    if (parseInt(this.$store.state.paramsapp.signataire.achatfacture.document)===0){
                        this.$refs.achat_facture_etat0.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.achatfacture.document)===1){
                        this.$refs.achat_facture_etat1.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.achatfacture.document)===2){
                        this.$refs.achat_facture_etat2.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.achatfacture.document)===3){
                        this.$refs.achat_facture_etat3.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.achatfacture.document)===4){
                        this.$refs.achat_facture_etat4.show(tabvalue);
                    }


                    if (parseInt(this.$store.state.paramsapp.signataire.achatfacture.document)===5){
                        this.$refs.achat_facture_etat5.show(tabvalue);
                    }



                }


                if(value.doctyp==='RF'){

                    tabvalue.jsoncltfrs.typcltfrs="FOURNISSEUR";

                    tabvalue.signature.titredoc=this.$store.state.paramsapp.signataire.achatretour.titredoc
                    tabvalue.signature.datasignataires=this.$store.state.paramsapp.signataire.achatretour.signataires


                    if (parseInt(this.$store.state.paramsapp.signataire.achatretour.document)===0){
                        this.$refs.achat_retour_etat0.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatretour.document)===1){
                        this.$refs.achat_retour_etat1.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatretour.document)===2){
                        this.$refs.achat_retour_etat2.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatretour.document)===3){
                        this.$refs.achat_retour_etat3.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatretour.document)===4){
                        this.$refs.achat_retour_etat4.show(tabvalue);
                    }

                    if (parseInt(this.$store.state.paramsapp.signataire.achatretour.document)===5){
                        this.$refs.achat_retour_etat5.show(tabvalue);
                    }



                }








            },




            btnopen(value){


                let titlemodal="Document "+value.numdoc

                let Item=value

                this.$refs.modalopenform.showupdate(titlemodal,"update",this.typedoc,Item,this.otherdata);

            },



            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            show(titlemodal){


                this.messagesucces="";
                this.messageerror="";
                this.titlemodal="Historique des documents"
                /* this.datatable=listdata
                 */

                this.indexbutton='1d';
                this.datatable=[];

                this.datedebut=this.$store.state.appserverdate
                this.datefin=this.$store.state.appserverdate


                this.load()



            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
            document.addEventListener('click', this.handleGlobalClick)
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleGlobalClick)
        }




    }
</script>
<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1100px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

/* Toolbar / filtres */
.cf-toolbar-row { display:flex; gap:0.75rem; align-items:center; }
.search-wrap { position:relative; flex:1; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:9px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; transition:border-color 0.2s; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.search-clear { position:absolute; right:8px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:var(--cf-faint); }
.cf-toolbar-meta { display:flex; align-items:center; justify-content:space-between; margin-top:0.7rem; gap:0.75rem; flex-wrap:wrap; }
.cf-period { display:inline-flex; gap:2px; background:var(--cf-surface-alt); padding:3px; border-radius:var(--cf-radius-sm); flex-wrap:wrap; }
.cf-perpage { display:flex; align-items:center; gap:0.4rem; font-size:0.8rem; color:var(--cf-muted); }
.cf-date-inp { height:34px; padding:0 8px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; font-size:0.8rem; color:var(--cf-ink); outline:none; }
.cf-date-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-select-wrap { position:relative; }
.cf-select--sm { appearance:none; height:34px; padding:0 28px 0 10px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; font-size:0.8rem; color:var(--cf-ink); cursor:pointer; }
.cf-select-arrow { position:absolute; right:10px; top:50%; transform:translateY(-50%); color:var(--cf-faint); pointer-events:none; }

/* Tableau */
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color .15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.65rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--center { text-align:center; }

/* Menu 3 points */
.ag-menu { position:absolute; top:calc(100% + 4px); right:0; z-index:30; min-width:180px; margin:0; padding:0.3rem; list-style:none;
    background:#fff; border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); box-shadow:var(--cf-shadow-md); }
.ag-menu-item { display:flex; align-items:center; width:100%; padding:0.45rem 0.6rem; border:0; background:transparent; font-size:0.8rem;
    color:var(--cf-ink); text-align:left; cursor:pointer; border-radius:var(--cf-radius-xs); white-space:nowrap; }
.ag-menu-item:hover { background:var(--cf-surface-alt); }
.ag-menu-item--danger { color:rgb(var(--danger)); }
.ag-menu-item--danger .cf-menu-icon { color:rgb(var(--danger)); }

/* Empty state */
.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }
.empty-state__sub { font-size:0.8rem; color:var(--cf-muted); margin:4px 0 0; }

/* Pagination */
.pagination { display:flex; align-items:center; gap:4px; }
.cf-ellipsis { padding:0 4px; color:var(--cf-faint); }
.page-btn { min-width:30px; height:30px; padding:0 8px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; color:var(--cf-ink); font-size:0.78rem; font-weight:600; cursor:pointer; transition:all 0.15s; }
.page-btn:hover:not(:disabled) { border-color:rgb(var(--primary) / 0.35); background:var(--cf-surface); }
.page-btn:disabled { opacity:0.5; cursor:not-allowed; }
.page-btn--active { background:rgb(var(--primary)); border-color:rgb(var(--primary)); color:#fff; }
.page-btn--nav { width:34px; display:inline-flex; align-items:center; justify-content:center; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .table td {
        cursor: pointer;
    }

    .h-screen{
        height: 300px!important;
    }

    .mybodyheight300px{
        height: 300px;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xxl { max-width:100%; }

        .h-screen,.mybodyheight300px{
            height: 100%!important;
        }


    }

</style>
